// import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueResource from 'vue-resource'

import Mint from 'mint-ui'
// import * as qiniu from 'qiniu-js'
import 'babel-polyfill'

import App from './App.vue'

import router from './router/index'
import store from './store/index'
import utils from './util/util'
import validator from './util/validator'
import wxApi from './util/wxapi'

import Cookies from 'js-cookie'

import 'swiper/dist/css/swiper.css'
import 'mint-ui/lib/style.css'
import './assets/style/reset.scss'
import './assets/style/common.scss'
import './assets/style/my-mint.scss'


// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';

// Sentry.init({
//   dsn: 'https://35b97da9d00f43b0883d24b96674016d@sentry.io/2823694',
//   integrations: [new Integrations.Vue({Vue, attachProps: true})],
// });

Vue.config.productionTip = false


const sessionStg = window.sessionStorage

Vue.mixin({
	beforeRouteLeave(to, from, next){
		const toRoute = to.path
		const fromRoute = from.path
		const h = JSON.parse(sessionStg.getItem(toRoute))
		if (h && h.history){
			if (from.meta && from.meta.keepAlive) {
				this.$destroy()
			}
		}
		next()
	},
	mounted() {
		setTimeout(() => {
			Vue.$indicator.close()
		}, 4000)
	},
	activated() {
		setTimeout(() => {
			Vue.$indicator.close()
		}, 4000)
	}
})


// 使用moment处理日期格式
// import Moment from 'moment'
Vue.filter('convertTime', function (timeStr) {
	return moment(timeStr).format('YYYY-MM-DD HH:mm:ss')
})
Vue.filter('convertDate', function (dateStr) {
	return moment(dateStr).format('YYYY-MM-DD')
})


router.beforeEach((to, from, next) => {
	const toRoute = to.path
	const fromRoute = from.path
	const h = JSON.parse(sessionStg.getItem(toRoute))
	if (h && h.history) {
		h.history =false
		sessionStg.removeItem(toRoute)
	} else {
		sessionStg.setItem(fromRoute || '/',JSON.stringify({
			history:true
		}))
	}
	
	let metaData = to.meta;
	if (metaData.setIsShowTabBar) {
		for (const key in to.params) {
			if (key == metaData.setIsShowTabBar) {
				metaData.isshowtabbar = parseInt(to.params[metaData.setIsShowTabBar]);
			}
		}
	}
	next();
});


Vue.prototype.utils = utils;
Vue.prototype.validator = validator;
Vue.prototype.wxApi = wxApi;
Vue.prototype.$cookie = Cookies;

Vue.use(Mint)
Vue.use(VueResource)
Vue.use(VueAwesomeSwiper)


window.router = router;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js